// import {
//   Button,
//   Form,
//   Input,
//   Table,
//   Select,
//   message,
//   Row,
//   Col,
//   Spin,
//   TreeSelect,
//   Modal,
// } from "antd";
// import { useEffect, useRef, useState } from "react";
// import {
//   fetchExecutionById,
//   postExecution,
//   putExecution,
// } from "../service/qualityChecklistExecution";
// import { InputNumber, Checkbox, Radio } from "antd";
// import { fetchBuildersByProductId } from "../../QualityConfiguration/QualityChecklistConfiguration/Service/qualityProcedureBuilder";
// import { useNavigate, useParams } from "react-router-dom";
// import { fetchDeviceTypeForFilter } from "../../QualityConfiguration/DeviceType/Service/deviceType";

// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import ExcelJS from "exceljs";
// import { saveAs } from "file-saver";
// import { fetchProduct } from "../../../../configuration/module/Product/Service/product";
// import ComportMqttListener from "../../../WebSocket/Component/ComportMqttListener";

// const exportToPDF = (
//   records,
//   categories,
//   productName,
//   checklistName,
//   serialNumber,
//   createdAt,
//   updatedAt,
//   fileName
// ) => {
//   const doc = new jsPDF();
//   const startY = 10;
//   const lineHeight = 7;

//   // 1️⃣ Metadata table
//   autoTable(doc, {
//     startY: startY,
//     theme: "grid",
//     head: [],
//     body: [
//       ["Product", productName],
//       ["Checklist", checklistName],
//       ["Serial Number", serialNumber],
//       ["Executed At", new Date(createdAt).toLocaleString()],
//       ["Updated At", new Date(updatedAt).toLocaleString()],
//     ],
//     styles: { fontSize: 11, cellPadding: 3 },
//     headStyles: { fillColor: [220, 220, 220], fontStyle: "bold" },
//   });

//   // 2️⃣ Main checklist table
//   const tableStartY = doc.lastAutoTable.finalY + 10; // space after metadata table
//   const tableData = records.map((r) => {
//     const deviceType =
//       categories.find((cat) => cat.uuid === r.deviceTypeId)?.deviceType ||
//       r.deviceTypeId;
//     const observation =
//       r.inputType === "OK_NOT_OK"
//         ? r.value === true
//           ? "OK"
//           : r.value === false
//           ? "NOT OK"
//           : "-"
//         : r.value?.toString() || "-";
//     return {
//       deviceType,
//       description: r.description,
//       observation,
//       record: r,
//     };
//   });

//   autoTable(doc, {
//     startY: tableStartY,
//     head: [["DeviceType", "Description", "Observation"]],
//     body: tableData.map((row) => [
//       row.deviceType,
//       row.description,
//       row.observation,
//       "", // placeholder for images
//     ]),
//     styles: { fontSize: 10, cellPadding: 3, valign: "middle" },
//     headStyles: {
//       fillColor: [220, 220, 220],
//       fontStyle: "bold",
//       minCellHeight: 0, // ✅ important
//       valign: "middle", // optional
//     },
//     columnStyles: { 3: { cellWidth: 60 } },
//     rowPageBreak: "avoid",
//     didParseCell: function (data) {
//       if (data.section === "body" && data.column.index === 3) {
//         const rec = tableData[data.row.index]?.record;
//         if (rec?.liveImages?.length) {
//           const totalHeight = rec.liveImages.length * 32;
//           if (totalHeight > data.cell.height) {
//             data.cell.styles.minCellHeight = totalHeight;
//           }
//         }
//       }
//     },
//     didDrawCell: function (data) {
//       if (data.section === "body" && data.column.index === 3) {
//         const rec = tableData[data.row.index]?.record;
//         if (rec?.liveImages?.length) {
//           let y = data.cell.y + 2;
//           const x = data.cell.x + 2;
//           const imgWidth = Math.max(10, data.cell.width - 4);
//           rec.liveImages.forEach((imgBase64) => {
//             const imgSrc = imgBase64.startsWith("data:image")
//               ? imgBase64
//               : `data:image/png;base64,${imgBase64}`;
//             doc.addImage(imgSrc, "PNG", x, y, imgWidth, 30);
//             y += 32;
//           });
//         }
//       }
//     },
//   });

//   doc.save(fileName || "Checklist_Execution.pdf");
// };

// const exportToExcel = async (
//   records,
//   categories,
//   productName,
//   checklistName,
//   serialNumber,
//   createdAt,
//   updatedAt,
//   fileName
// ) => {
//   const SCALE_W = 1.25; // +25% width
//   const SCALE_H = 1.25 * 1.2; // +25% then +20% height

//   const BASE_IMG_W = 100;
//   const BASE_IMG_H = 60;
//   const BASE_ROW_H = 45;

//   const IMG_W = Math.round(BASE_IMG_W * SCALE_W); // 125
//   const IMG_H = Math.round(BASE_IMG_H * SCALE_H); // 90
//   const ROW_H = Math.round(BASE_ROW_H * SCALE_H); // 68

//   const workbook = new ExcelJS.Workbook();
//   const sheet = workbook.addWorksheet("Checklist");

//   // 1️⃣ Add metadata rows at the top
//   sheet.addRow(["Product", productName]);
//   sheet.addRow(["Checklist", checklistName]);
//   sheet.addRow(["Serial Number", serialNumber]);
//   sheet.addRow(["Executed At", new Date(createdAt).toLocaleString()]);
//   sheet.addRow(["Last Updated At", new Date(updatedAt).toLocaleString()]);
//   sheet.eachRow((row, rowNumber) => {
//     const firstCell = row.getCell(1);
//     firstCell.font = { bold: true };
//   });

//   // 2️⃣ Add empty row for spacing
//   sheet.addRow([]);

//   // 3️⃣ Add table headers
//   const headerRow = sheet.addRow(["DeviceType", "Description", "Observation"]);
//   headerRow.font = { bold: true };
//   headerRow.eachCell((cell) => {
//     cell.alignment = {
//       vertical: "middle",
//       horizontal: "center",
//       wrapText: true,
//     };
//   });

//   // track max width needed for image column (in Excel column width units)
//   let maxImageColWidthUnits = 10;

//   // 4️⃣ Add table rows
//   for (const record of records) {
//     const deviceTypeName =
//       categories.find((c) => c.uuid === record.deviceTypeId)?.deviceType ||
//       record.deviceTypeId;
//     const obs =
//       record.inputType === "OK_NOT_OK"
//         ? record.value === true
//           ? "OK"
//           : record.value === false
//           ? "NOT OK"
//           : "-"
//         : record.value?.toString() || "-";

//     const row = sheet.addRow([deviceTypeName, record.description, obs, ""]);
//     row.eachCell((cell) => {
//       cell.alignment = {
//         vertical: "middle",
//         horizontal: "center",
//         wrapText: true,
//       };
//     });

//     // Add live images (scaled)
//     if (record.liveImages?.length) {
//       let startRow = row.number;
//       for (let i = 0; i < record.liveImages.length; i++) {
//         const img = record.liveImages[i];
//         const imageId = workbook.addImage({
//           base64: img.startsWith("data:image") ? img.split(",")[1] : img,
//           extension: "png",
//         });

//         sheet.addImage(imageId, {
//           tl: { col: 3 + 0.2, row: startRow - 1 + i + 0.2 },
//           ext: { width: IMG_W, height: IMG_H },
//         });

//         // row height scaled with image height
//         sheet.getRow(startRow + i).height = ROW_H * 1.1;
//       }

//       // merge text columns for multiple image rows
//       if (record.liveImages.length > 1) {
//         sheet.mergeCells(
//           `A${row.number}:A${row.number + record.liveImages.length - 1}`
//         );
//         sheet.mergeCells(
//           `B${row.number}:B${row.number + record.liveImages.length - 1}`
//         );
//         sheet.mergeCells(
//           `C${row.number}:C${row.number + record.liveImages.length - 1}`
//         );
//       }

//       // compute candidate width for image column
//       const candidateUnits = IMG_W / 7; // px → excel col units
//       if (candidateUnits > maxImageColWidthUnits) {
//         maxImageColWidthUnits = candidateUnits;
//       }
//     }
//   }

//   // 5️⃣ Auto-fit column widths for text columns
//   sheet.columns.forEach((col, idx) => {
//     if (idx === 3) return; // skip image column (D)
//     let maxLength = 10;
//     col.eachCell({ includeEmpty: true }, (cell) => {
//       const columnLength = cell.value ? cell.value.toString().length : 0;
//       if (columnLength > maxLength) maxLength = columnLength;
//     });
//     col.width = maxLength + 2;
//   });

//   // 6️⃣ Adjust Live Images column width
//   const finalImageColWidth = Math.max(
//     sheet.getColumn(4).width || 10,
//     Math.round(maxImageColWidthUnits + 2)
//   );
//   sheet.getColumn(4).width = finalImageColWidth;

//   const buffer = await workbook.xlsx.writeBuffer();
//   saveAs(new Blob([buffer]), fileName || "Checklist_Execution.xlsx");
// };

// const ImageWithDimensions = ({ base64, dimensions = [] }) => {
//   const imgRef = useRef(null);
//   const [renderSize, setRenderSize] = useState({ width: 1, height: 1 });
//   const [naturalSize, setNaturalSize] = useState({ width: 1, height: 1 });

//   const src = `data:image/*;base64,${base64}`;

//   useEffect(() => {
//     if (!imgRef.current) return;

//     const img = imgRef.current;

//     const updateSizes = () => {
//       setRenderSize({
//         width: img.clientWidth,
//         height: img.clientHeight,
//       });

//       setNaturalSize({
//         width: img.naturalWidth,
//         height: img.naturalHeight,
//       });
//     };

//     if (img.complete) updateSizes();
//     img.onload = updateSizes;

//     window.addEventListener("resize", updateSizes);
//     return () => window.removeEventListener("resize", updateSizes);
//   }, []);

//   return (
//     <div style={{ position: "relative" }}>
//       <img
//         ref={imgRef}
//         src={src}
//         alt="preview"
//         style={{ width: "100%", display: "block" }}
//       />

//       <svg
//         style={{
//           position: "absolute",
//           inset: 0,
//           width: "100%",
//           height: "100%",
//           pointerEvents: "none",
//         }}
//       >
//         <defs>
//           <linearGradient id="blinkGradient">
//             <stop offset="0%">
//               <animate
//                 attributeName="stop-color"
//                 values="white;blue;white"
//                 dur="1s"
//                 repeatCount="indefinite"
//               />
//             </stop>
//             <stop offset="100%">
//               <animate
//                 attributeName="stop-color"
//                 values="white;blue;white"
//                 dur="1s"
//                 repeatCount="indefinite"
//               />
//             </stop>
//           </linearGradient>

//           <marker
//             id="dimArrowStart"
//             markerWidth="24"
//             markerHeight="12"
//             refX="14"
//             refY="6"
//             orient="auto"
//           >
//             <path d="M24 0 L12 6 L24 12 Z" fill="red" />
//           </marker>

//           <marker
//             id="dimArrowEnd"
//             markerWidth="24"
//             markerHeight="12"
//             refX="10"
//             refY="6"
//             orient="auto"
//           >
//             <path d="M0 0 L12 6 L0 12 Z" fill="red" />
//           </marker>
//         </defs>

//         {dimensions.map((d, idx) => {
//           const x1 = (d.x1 / naturalSize.width) * renderSize.width;
//           const y1 = (d.y1 / naturalSize.height) * renderSize.height;
//           const x2 = (d.x2 / naturalSize.width) * renderSize.width;
//           const y2 = (d.y2 / naturalSize.height) * renderSize.height;

//           return (
//             <line
//               key={idx}
//               x1={x1}
//               y1={y1}
//               x2={x2}
//               y2={y2}
//               stroke="url(#blinkGradient)"
//               strokeWidth={2}
//               markerStart="url(#dimArrowEnd)"
//               markerEnd="url(#dimArrowStart)"
//             />
//           );
//         })}
//       </svg>
//     </div>
//   );
// };
// const DECISION_OPTIONS = [
//   { label: "Accepted", value: "ACCEPTED" },
//   { label: "Rejected", value: "REJECT" },
//   { label: "Rework", value: "REWORK" },
// ];

// const QualityPlanChecklistExecutionForm = ({ mode }) => {
//   const { id } = useParams();
//   const [form] = Form.useForm();
//   const [records, setRecords] = useState([]);
//   const [editData, setEditData] = useState(null);
//   const [categories, setCategories] = useState([]);
//   const [product, setProduct] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);
//   const [executions, setExecutions] = useState([]);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [selectedImage, setSelectedImage] = useState(null);
//   const navigate = useNavigate();
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [selectedChecklist, setSelectedChecklist] = useState(null);
//   const [messageApi, contextHolder] = message.useMessage();
//   const [comportData, setComportData] = useState({});

//   const getChickListByProductId = async (productId, preselectChecklistId) => {
//     setSelectedProduct(productId);
//     setIsLoading(true);
//     try {
//       const res = await fetchBuildersByProductId(productId);
//       setExecutions(res.data);

//       // ✅ only after executions are ready
//       if (preselectChecklistId) {
//         setSelectedChecklist(preselectChecklistId);
//         const selected = res.data.find(
//           (exec) => exec.uuid === preselectChecklistId
//         );
//         if (selected) {
//           let normalized = (selected.records || []).map((r) => ({
//             ...r,
//             key: r.uuid || Date.now(),
//             liveImages: r.liveImages || [],
//             sampleImages: r.sampleImages || [],
//           }));
//           const mergeWithObservations = (templateRecords, observations) => {
//             return templateRecords.map((r) => {
//               const obs = observations.find((o) => o.recordId === r.uuid);
//               return {
//                 ...r,
//                 value: obs ? obs.value : r.value,
//               };
//             });
//           };

//           if (editData?.observations) {
//             normalized = mergeWithObservations(
//               normalized,
//               editData.observations
//             );
//           }

//           setRecords(normalized);
//         }
//       } else {
//         setSelectedChecklist(null);
//       }
//     } finally {
//       setIsLoading(false);
//     }
//   };
//   const getDecision = (record) => {
//     if (record.inputType !== "DOUBLE") return null;

//     const measured = record.measuredValue;
//     const nominal = record.value;
//     const tol = record.tolerance;

//     if (
//       measured === undefined ||
//       measured === null ||
//       nominal === undefined ||
//       tol === undefined
//     ) {
//       return null;
//     }

//     const lowerLimit = nominal - tol;
//     const upperLimit = nominal + tol;

//     if (measured >= lowerLimit && measured <= upperLimit) {
//       return "ACCEPTED";
//     }

//     if (measured < lowerLimit) {
//       return record.lowerAction; // "REJECT" or "REWORK"
//     }

//     if (measured > upperLimit) {
//       return record.upperAction; // "REJECT" or "REWORK"
//     }

//     return null;
//   };
//   const DEVICE_ID = "qwertyuil";

//   const columns = [
//     {
//       title: "DeviceType",
//       dataIndex: "deviceTypeId",
//       key: "deviceTypeId",
//       render: (_, record) =>
//         categories.find((cat) => cat.id === record.deviceTypeId)?.deviceType,
//     },
//     {
//       title: "Description",
//       dataIndex: "description",
//       key: "description",
//       render: (_, record) => record.description,
//     },
//     {
//       title: "Value",
//       dataIndex: "value",
//       key: "value",
//       render: (value, record) => {
//         if (record.inputType !== "DOUBLE") return "-";
//         return `${value} ${record.unit}`;
//       },
//     },
//     {
//       title: "Tolerance",
//       dataIndex: "tolerance",
//       key: "tolerance",
//       render: (value, record) => {
//         if (record.inputType !== "DOUBLE") return "-";
//         return `± ${value} ${record.unit}`;
//       },
//     },
//     {
//       title: "Observation",
//       dataIndex: "response",
//       key: "response",
//       render: (_, record) => {
//         switch (record.inputType) {
//           case "OK_NOT_OK":
//             return (
//               <div style={{ display: "flex", gap: "1rem" }}>
//                 <Checkbox
//                   checked={record.measuredValue === true}
//                   disabled={mode === "view"}
//                   onChange={() => {
//                     record.measuredValue = true;
//                     setRecords([...records]);
//                   }}
//                 >
//                   OK
//                 </Checkbox>
//                 <Checkbox
//                   checked={record.measuredValue === false}
//                   disabled={mode === "view"}
//                   onChange={() => {
//                     record.measuredValue = false;
//                     setRecords([...records]);
//                   }}
//                 >
//                   NOT OK
//                 </Checkbox>
//               </div>
//             );

//           case "OPTIONS":
//             return (
//               <Radio.Group
//                 value={record.measuredValue}
//                 disabled={mode === "view"}
//                 onChange={(e) => {
//                   record.measuredValue = e.target.value;
//                   setRecords([...records]);
//                 }}
//               >
//                 {record.options?.map((opt, idx) => (
//                   <Radio key={idx} value={opt}>
//                     {opt}
//                   </Radio>
//                 ))}
//               </Radio.Group>
//             );

//           case "STRING":
//             return (
//               <Input
//                 // defaultValue={record.value}
//                 value={record.measuredValue || ""}
//                 disabled={mode === "view"}
//                 onChange={(e) => {
//                   record.measuredValue = e.target.value;
//                   setRecords([...records]);
//                 }}
//               />
//             );

//           case "DOUBLE":
//             return (
//               // <InputNumber
//               //   style={{ width: "100%" }}
//               //   value={record.measuredValue}
//               //   disabled={mode === "view"}
//               //   onChange={(val) => {
//               //     record.measuredValue = val; // ✅ correct
//               //     setRecords([...records]);
//               //   }}
//               // />
//               <Input
//                 type="text"
//                 value={record.measuredValue ?? ""}
//                 disabled={mode === "view"}
//                 onPaste={(e) => {
//                   e.preventDefault(); // 🚫 stop default paste

//                   const pastedText = e.clipboardData.getData("text").trim();

//                   // Split by space(s)
//                   const parts = pastedText.split(/\s+/);

//                   // Expected format: DEVICE_ID VALUE
//                   if (parts.length !== 2) {
//                     messageApi.open({
//                       type: "error",
//                       content: "Invalid device data format",
//                     });
//                     return;
//                   }

//                   const [deviceId, value] = parts;

//                   // ❌ Device mismatch
//                   if (deviceId !== DEVICE_ID) {
//                     messageApi.open({
//                       type: "error",
//                       content: "Send value from allocated device",
//                     });
//                     return;
//                   }

//                   // ❌ Not a number
//                   if (isNaN(value)) {
//                     messageApi.open({
//                       type: "error",
//                       content: "Invalid numeric value from device",
//                     });
//                     return;
//                   }

//                   // ✅ Valid → update only numeric value
//                   record.measuredValue = Number(value);
//                   setRecords([...records]);
//                 }}
//                 onChange={(e) => {
//                   // Allow manual typing only for numbers
//                   const val = e.target.value;
//                   if (!isNaN(val)) {
//                     record.measuredValue = val;
//                     setRecords([...records]);
//                   }
//                 }}
//               />
//             );

//           default:
//             return <span>-</span>;
//         }
//       },
//     },
//     // {
//     //   title: "Decision",
//     //   key: "decision",
//     //   align: "center",
//     //   render: (_, record) => {
//     //     const decision = getDecision(record);

//     //     const colorMap = {
//     //       ACCEPTED: "green",
//     //       REJECT: "red",
//     //       REWORK: "orange",
//     //     };

//     //     return (
//     //       <span
//     //         style={{
//     //           fontWeight: 600,
//     //           color: colorMap[decision] || "#999",
//     //         }}
//     //       >
//     //         {decision || "-"}
//     //       </span>
//     //     );
//     //   },
//     // },
//     {
//       title: "Decision",
//       key: "decision",
//       align: "center",
//       render: (_, record) => {
//         // 🔹 DOUBLE → auto decision
//         if (record.inputType === "DOUBLE") {
//           const decision = getDecision(record);

//           const colorMap = {
//             ACCEPTED: "green",
//             REJECT: "red",
//             REWORK: "orange",
//           };

//           return (
//             <span
//               style={{
//                 fontWeight: 600,
//                 color: colorMap[decision] || "#999",
//               }}
//             >
//               {decision || "-"}
//             </span>
//           );
//         }

//         // 🔹 NON-DOUBLE → user selects decision
//         return (
//           <Select
//             style={{ width: 140 }}
//             placeholder="Select"
//             value={record.decision}
//             disabled={mode === "view"}
//             options={DECISION_OPTIONS}
//             onChange={(value) => {
//               record.decision = value;
//               setRecords([...records]);
//             }}
//           />
//         );
//       },
//     },
//     {
//       title: "Sample Images",
//       dataIndex: "sampleImages",
//       key: "sampleImages",
//       render: (_, record) => (
//         <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
//           {record.sampleImages?.map((img, idx) => {
//             let src = "";

//             // ✅ case 1: image object with base64
//             if (img?.base64) {
//               src = `data:image/webp;base64,${img.base64}`;
//             }
//             // ✅ case 2: image object with url
//             else if (img?.url) {
//               src = img.url;
//             }
//             // ✅ case 3: raw base64 string (fallback)
//             else if (typeof img === "string") {
//               src = `data:image/png;base64,${img}`;
//             }

//             if (!src) return null;

//             return (
//               <img
//                 key={idx}
//                 src={src}
//                 alt={img.fileName || `sample-${idx}`}
//                 style={{
//                   width: 100,
//                   height: 100,
//                   objectFit: "cover",
//                   borderRadius: 4,
//                   cursor: "pointer",
//                 }}
//                 // onClick={() => {
//                 //   setIsModalOpen(true);
//                 //   setSelectedImage(src);
//                 // }}
//                 onClick={() => {
//                   setIsModalOpen(true);
//                   setSelectedImage({
//                     base64: img.base64,
//                     dimensions: img.dimensions || [],
//                     originalSize: {
//                       width: img.width, // MUST come from backend
//                       height: img.height, // MUST come from backend
//                     },
//                   });
//                 }}
//               />
//             );
//           })}

//           {(!record.sampleImages || record.sampleImages.length === 0) &&
//             "No image available"}
//         </div>
//       ),
//     },
//   ];

//   const onFinish = (values) => {
//     const payload = {
//       serialNumber: values.serialNumber, // unique id
//       productId: selectedProduct,
//       checklistId: selectedChecklist,
//       observations: records.map((r) => ({
//         recordId: r.uuid || null, // optional: link to checklist record
//         inputType: r.inputType, // send type for backend parsing
//         value: r.value, // actual observation
//         liveImages: r.liveImages || [],
//       })),
//     };

//     saveData(payload);
//   };

//   const saveData = async (data) => {
//     setIsLoading(true);
//     try {
//       let res;
//       if (editData) res = await putExecution(data, editData.uuid);
//       else res = await postExecution(data);
//       messageApi.open({
//         type: "success",
//         content: `Execution ${editData ? "updated" : "added"} successfully`,
//       });

//       if (editData) {
//         setTimeout(() => {
//           navigate({ pathname: "/check-list" });
//         }, 2000);
//       } else {
//         form.resetFields(["serialNumber"]);
//         setRecords((prev) =>
//           prev.map((r) => ({
//             ...r,
//             value: undefined,
//           }))
//         );
//       }
//     } catch {
//       messageApi.open({
//         type: "error",
//         content: "Error saving execution",
//       });
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const onSelectTemplate = (value) => {
//     setSelectedChecklist(value); // ✅ capture checklistId
//     const selected = executions.find((exec) => exec.uuid === value);

//     const normalized = (selected?.records || []).map((r) => ({
//       ...r,
//       key: r.uuid || Date.now(),
//       sampleImages: r.sampleImages || [],
//     }));

//     setRecords(normalized);
//   };

//   const buildTreeData = (nodes) =>
//     nodes.map((node) => {
//       // const isLeaf = !node.children || node.children.length === 0;
//       return {
//         title: node.productName,
//         value: node.uuid,
//         key: node.uuid,
//         // selectable: isLeaf,
//         // disabled: !isLeaf,
//         children: node.children ? buildTreeData(node.children) : [],
//       };
//     });

//   useEffect(() => {
//     (async () => {
//       setIsLoading(true);
//       try {
//         const res = await fetchProduct();
//         setProduct(buildTreeData(res.data));

//         if (editData) {
//           form.setFieldsValue({ serialNumber: editData.serialNumber });
//           getChickListByProductId(editData.productId, editData.checklistId);

//           // also load existing execution record rows (observations, images, etc.)
//           const initialRecords = (
//             editData.checkListExecutionRecordList || []
//           ).map((r) => ({
//             ...r,
//             key: r.uuid || Date.now(),
//             liveImages: r.liveImages || [],
//             sampleImages: r.sampleImages || [],
//           }));
//           setRecords(initialRecords);
//         } else {
//           form.resetFields();
//           setRecords([]);
//         }
//       } catch (err) {
//         messageApi.open({
//           type: "error",
//           content: "Network error while fetching products",
//         });
//       } finally {
//         setIsLoading(false);
//       }
//       setIsLoading(true);
//       try {
//         const res = await fetchDeviceTypeForFilter();
//         setCategories(res.data);
//       } catch (err) {
//         messageApi.open({
//           type: "error",
//           content: "Network error while fetching device type",
//         });
//       } finally {
//         setIsLoading(false);
//       }
//     })();
//   }, [editData, form]);

//   useEffect(() => {
//     if (id) {
//       // Fetch existing data for editing
//       const fetchData = async () => {
//         const res = await fetchExecutionById(id);
//         setEditData(res.data);
//       };
//       fetchData();
//     }
//   }, [id]);

//   const getFileName = (type) => {
//     const checklistName =
//       executions.find((exec) => exec.uuid === selectedChecklist)
//         ?.checklistName || "Checklist";
//     const timestamp = new Date()
//       .toISOString()
//       .slice(0, 19)
//       .replace(/[:T]/g, "-");
//     return `${checklistName}_${timestamp}.${type}`;
//   };

//   console.log("product", product, selectedProduct);

//   // const productName =
//   //   product.find((p) => p.value === selectedProduct)?.title || "";
//   function findTitleByValue(tree, value) {
//     for (const node of tree) {
//       if (node.value === value) return node.title;
//       if (node.children) {
//         const childResult = findTitleByValue(node.children, value);
//         if (childResult) return childResult;
//       }
//     }
//     return "";
//   }

//   const productName = findTitleByValue(product, selectedProduct);

//   const checklistName =
//     executions.find((e) => e.uuid === selectedChecklist)?.checklistName || "";
//   const serialNumber = form.getFieldValue("serialNumber") || "";
//   const createdAt = editData?.createdAt || new Date();
//   const updatedAt = editData?.updatedAt || new Date();
//   const handleMessage = (data) => {
//     setComportData(data);
//   };
//   return (
//     <Spin spinning={isLoading}>
//       <div style={{ fontSize: "1rem", fontWeight: 700 }}>
//         Quality Plan Execution
//       </div>
//       <ComportMqttListener onMessage={handleMessage} />
//       {contextHolder}
//       <br />
//       <Row gutter={[16, 16]}>
//         <Col>
//           <TreeSelect
//             value={selectedProduct}
//             disabled={mode === "view"}
//             treeData={product}
//             placeholder="Select Product"
//             style={{ width: "100%", minWidth: 240 }}
//             treeDefaultExpandAll={false}
//             onChange={(value) => getChickListByProductId(value)}
//           />
//         </Col>
//         {executions.length > 0 && (
//           <Col>
//             <Select
//               value={selectedChecklist}
//               placeholder="Select Checklist"
//               disabled={mode === "view"}
//               style={{ width: "100%", minWidth: 240 }}
//               options={executions.map((exec) => ({
//                 label: exec.procedureName,
//                 value: exec.uuid,
//               }))}
//               onChange={onSelectTemplate}
//             />
//           </Col>
//         )}
//         {mode === "view" && (
//           <Col>
//             <Button
//               style={{ marginRight: "1rem" }}
//               onClick={() =>
//                 // exportToPDF(records, categories, getFileName("pdf"))
//                 exportToPDF(
//                   records,
//                   categories,
//                   productName,
//                   checklistName,
//                   serialNumber,
//                   createdAt,
//                   updatedAt,
//                   getFileName("pdf")
//                 )
//               }
//             >
//               Download PDF
//             </Button>
//             <Button
//               onClick={() =>
//                 // exportToExcel(records, categories, getFileName("xlsx"))
//                 exportToExcel(
//                   records,
//                   categories,
//                   productName,
//                   checklistName,
//                   serialNumber,
//                   createdAt,
//                   updatedAt,
//                   getFileName("xlsx")
//                 )
//               }
//             >
//               Download Excel
//             </Button>
//           </Col>
//         )}
//       </Row>
//       <br />
//       <Form form={form} layout="vertical" onFinish={onFinish}>
//         <Form.Item
//           name="serialNumber"
//           label="Serial Number"
//           rules={[{ required: true, message: "Please input serial number!" }]}
//         >
//           <Input disabled={mode === "view"} />
//         </Form.Item>

//         <Table
//           rowKey="key"
//           scroll={{ x: "max-content" }}
//           columns={columns}
//           disabled={mode === "view"}
//           dataSource={records} // ✅ use state, not template
//           pagination={false}
//         />

//         <Form.Item
//           style={{
//             marginTop: 20,
//             textAlign: "right",
//           }}
//         >
//           <Button
//             style={{ marginRight: "1rem" }}
//             onClick={() => {
//               navigate({ pathname: "/check-list-builder/check-list" });
//             }}
//           >
//             Cancel
//           </Button>
//           {mode === "view" || (
//             <Button type="primary" htmlType="submit">
//               Submit
//             </Button>
//           )}
//         </Form.Item>
//       </Form>
//       <Modal
//         title="Image Preview"
//         open={isModalOpen}
//         onCancel={() => setIsModalOpen(false)}
//         footer={null}
//         width={900}
//       >
//         {selectedImage && (
//           <ImageWithDimensions
//             base64={selectedImage.base64}
//             dimensions={selectedImage.dimensions}
//           />
//         )}
//       </Modal>
//     </Spin>
//   );
// };

// export default QualityPlanChecklistExecutionForm;
import {
  Button,
  Form,
  Input,
  Table,
  Select,
  message,
  Row,
  Col,
  Spin,
  TreeSelect,
  Modal,
} from "antd";
import { useEffect, useRef, useState } from "react";
import {
  fetchExecutionById,
  postExecution,
  putExecution,
} from "../service/qualityChecklistExecution";
import { InputNumber, Checkbox, Radio } from "antd";
import { fetchBuildersByProductId } from "../../QualityConfiguration/QualityChecklistConfiguration/Service/qualityProcedureBuilder";
import { useNavigate, useParams } from "react-router-dom";
import { fetchDeviceTypeForFilter } from "../../QualityConfiguration/DeviceType/Service/deviceType";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { fetchProduct } from "../../../../configuration/module/Product/Service/product";
import ComportMqttListener from "../../../WebSocket/Component/ComportMqttListener";

const exportToPDF = (
  records,
  categories,
  productName,
  checklistName,
  serialNumber,
  createdAt,
  updatedAt,
  fileName
) => {
  const doc = new jsPDF();
  const startY = 10;
  const lineHeight = 7;

  // 1️⃣ Metadata table
  autoTable(doc, {
    startY: startY,
    theme: "grid",
    head: [],
    body: [
      ["Product", productName],
      ["Checklist", checklistName],
      ["Serial Number", serialNumber],
      ["Executed At", new Date(createdAt).toLocaleString()],
      ["Updated At", new Date(updatedAt).toLocaleString()],
    ],
    styles: { fontSize: 11, cellPadding: 3 },
    headStyles: { fillColor: [220, 220, 220], fontStyle: "bold" },
  });

  // 2️⃣ Main checklist table
  const tableStartY = doc.lastAutoTable.finalY + 10; // space after metadata table
  const tableData = records.map((r) => {
    const deviceType =
      categories.find((cat) => cat.uuid === r.deviceTypeId)?.deviceType ||
      r.deviceTypeId;
    const observation =
      r.inputType === "OK_NOT_OK"
        ? r.value === true
          ? "OK"
          : r.value === false
          ? "NOT OK"
          : "-"
        : r.value?.toString() || "-";
    return {
      deviceType,
      description: r.description,
      observation,
      record: r,
    };
  });

  autoTable(doc, {
    startY: tableStartY,
    head: [["DeviceType", "Description", "Observation"]],
    body: tableData.map((row) => [
      row.deviceType,
      row.description,
      row.observation,
      "", // placeholder for images
    ]),
    styles: { fontSize: 10, cellPadding: 3, valign: "middle" },
    headStyles: {
      fillColor: [220, 220, 220],
      fontStyle: "bold",
      minCellHeight: 0, // ✅ important
      valign: "middle", // optional
    },
    columnStyles: { 3: { cellWidth: 60 } },
    rowPageBreak: "avoid",
    didParseCell: function (data) {
      if (data.section === "body" && data.column.index === 3) {
        const rec = tableData[data.row.index]?.record;
        if (rec?.liveImages?.length) {
          const totalHeight = rec.liveImages.length * 32;
          if (totalHeight > data.cell.height) {
            data.cell.styles.minCellHeight = totalHeight;
          }
        }
      }
    },
    didDrawCell: function (data) {
      if (data.section === "body" && data.column.index === 3) {
        const rec = tableData[data.row.index]?.record;
        if (rec?.liveImages?.length) {
          let y = data.cell.y + 2;
          const x = data.cell.x + 2;
          const imgWidth = Math.max(10, data.cell.width - 4);
          rec.liveImages.forEach((imgBase64) => {
            const imgSrc = imgBase64.startsWith("data:image")
              ? imgBase64
              : `data:image/png;base64,${imgBase64}`;
            doc.addImage(imgSrc, "PNG", x, y, imgWidth, 30);
            y += 32;
          });
        }
      }
    },
  });

  doc.save(fileName || "Checklist_Execution.pdf");
};

const exportToExcel = async (
  records,
  categories,
  productName,
  checklistName,
  serialNumber,
  createdAt,
  updatedAt,
  fileName
) => {
  const SCALE_W = 1.25; // +25% width
  const SCALE_H = 1.25 * 1.2; // +25% then +20% height

  const BASE_IMG_W = 100;
  const BASE_IMG_H = 60;
  const BASE_ROW_H = 45;

  const IMG_W = Math.round(BASE_IMG_W * SCALE_W); // 125
  const IMG_H = Math.round(BASE_IMG_H * SCALE_H); // 90
  const ROW_H = Math.round(BASE_ROW_H * SCALE_H); // 68

  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Checklist");

  // 1️⃣ Add metadata rows at the top
  sheet.addRow(["Product", productName]);
  sheet.addRow(["Checklist", checklistName]);
  sheet.addRow(["Serial Number", serialNumber]);
  sheet.addRow(["Executed At", new Date(createdAt).toLocaleString()]);
  sheet.addRow(["Last Updated At", new Date(updatedAt).toLocaleString()]);
  sheet.eachRow((row, rowNumber) => {
    const firstCell = row.getCell(1);
    firstCell.font = { bold: true };
  });

  // 2️⃣ Add empty row for spacing
  sheet.addRow([]);

  // 3️⃣ Add table headers
  const headerRow = sheet.addRow(["DeviceType", "Description", "Observation"]);
  headerRow.font = { bold: true };
  headerRow.eachCell((cell) => {
    cell.alignment = {
      vertical: "middle",
      horizontal: "center",
      wrapText: true,
    };
  });

  // track max width needed for image column (in Excel column width units)
  let maxImageColWidthUnits = 10;

  // 4️⃣ Add table rows
  for (const record of records) {
    const deviceTypeName =
      categories.find((c) => c.uuid === record.deviceTypeId)?.deviceType ||
      record.deviceTypeId;
    const obs =
      record.inputType === "OK_NOT_OK"
        ? record.value === true
          ? "OK"
          : record.value === false
          ? "NOT OK"
          : "-"
        : record.value?.toString() || "-";

    const row = sheet.addRow([deviceTypeName, record.description, obs, ""]);
    row.eachCell((cell) => {
      cell.alignment = {
        vertical: "middle",
        horizontal: "center",
        wrapText: true,
      };
    });

    // Add live images (scaled)
    if (record.liveImages?.length) {
      let startRow = row.number;
      for (let i = 0; i < record.liveImages.length; i++) {
        const img = record.liveImages[i];
        const imageId = workbook.addImage({
          base64: img.startsWith("data:image") ? img.split(",")[1] : img,
          extension: "png",
        });

        sheet.addImage(imageId, {
          tl: { col: 3 + 0.2, row: startRow - 1 + i + 0.2 },
          ext: { width: IMG_W, height: IMG_H },
        });

        // row height scaled with image height
        sheet.getRow(startRow + i).height = ROW_H * 1.1;
      }

      // merge text columns for multiple image rows
      if (record.liveImages.length > 1) {
        sheet.mergeCells(
          `A${row.number}:A${row.number + record.liveImages.length - 1}`
        );
        sheet.mergeCells(
          `B${row.number}:B${row.number + record.liveImages.length - 1}`
        );
        sheet.mergeCells(
          `C${row.number}:C${row.number + record.liveImages.length - 1}`
        );
      }

      // compute candidate width for image column
      const candidateUnits = IMG_W / 7; // px → excel col units
      if (candidateUnits > maxImageColWidthUnits) {
        maxImageColWidthUnits = candidateUnits;
      }
    }
  }

  // 5️⃣ Auto-fit column widths for text columns
  sheet.columns.forEach((col, idx) => {
    if (idx === 3) return; // skip image column (D)
    let maxLength = 10;
    col.eachCell({ includeEmpty: true }, (cell) => {
      const columnLength = cell.value ? cell.value.toString().length : 0;
      if (columnLength > maxLength) maxLength = columnLength;
    });
    col.width = maxLength + 2;
  });

  // 6️⃣ Adjust Live Images column width
  const finalImageColWidth = Math.max(
    sheet.getColumn(4).width || 10,
    Math.round(maxImageColWidthUnits + 2)
  );
  sheet.getColumn(4).width = finalImageColWidth;

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), fileName || "Checklist_Execution.xlsx");
};

const ImageWithDimensions = ({ base64, dimensions = [] }) => {
  const imgRef = useRef(null);
  const [renderSize, setRenderSize] = useState({ width: 1, height: 1 });
  const [naturalSize, setNaturalSize] = useState({ width: 1, height: 1 });

  const src = `data:image/*;base64,${base64}`;

  useEffect(() => {
    if (!imgRef.current) return;

    const img = imgRef.current;

    const updateSizes = () => {
      setRenderSize({
        width: img.clientWidth,
        height: img.clientHeight,
      });

      setNaturalSize({
        width: img.naturalWidth,
        height: img.naturalHeight,
      });
    };

    if (img.complete) updateSizes();
    img.onload = updateSizes;

    window.addEventListener("resize", updateSizes);
    return () => window.removeEventListener("resize", updateSizes);
  }, []);

  return (
    <div style={{ position: "relative" }}>
      <img
        ref={imgRef}
        src={src}
        alt="preview"
        style={{ width: "100%", display: "block" }}
      />

      <svg
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          pointerEvents: "none",
        }}
      >
        <defs>
          <linearGradient id="blinkGradient">
            <stop offset="0%">
              <animate
                attributeName="stop-color"
                values="white;blue;white"
                dur="1s"
                repeatCount="indefinite"
              />
            </stop>
            <stop offset="100%">
              <animate
                attributeName="stop-color"
                values="white;blue;white"
                dur="1s"
                repeatCount="indefinite"
              />
            </stop>
          </linearGradient>

          <marker
            id="dimArrowStart"
            markerWidth="24"
            markerHeight="12"
            refX="14"
            refY="6"
            orient="auto"
          >
            <path d="M24 0 L12 6 L24 12 Z" fill="red" />
          </marker>

          <marker
            id="dimArrowEnd"
            markerWidth="24"
            markerHeight="12"
            refX="10"
            refY="6"
            orient="auto"
          >
            <path d="M0 0 L12 6 L0 12 Z" fill="red" />
          </marker>
        </defs>

        {dimensions.map((d, idx) => {
          const x1 = (d.x1 / naturalSize.width) * renderSize.width;
          const y1 = (d.y1 / naturalSize.height) * renderSize.height;
          const x2 = (d.x2 / naturalSize.width) * renderSize.width;
          const y2 = (d.y2 / naturalSize.height) * renderSize.height;

          return (
            <line
              key={idx}
              x1={x1}
              y1={y1}
              x2={x2}
              y2={y2}
              stroke="url(#blinkGradient)"
              strokeWidth={2}
              markerStart="url(#dimArrowEnd)"
              markerEnd="url(#dimArrowStart)"
            />
          );
        })}
      </svg>
    </div>
  );
};
const DECISION_OPTIONS = [
  { label: "Accepted", value: "ACCEPTED" },
  { label: "Rejected", value: "REJECT" },
  { label: "Rework", value: "REWORK" },
];

const QualityPlanChecklistExecutionForm = ({ mode }) => {
  const { id } = useParams();
  const [form] = Form.useForm();
  const [records, setRecords] = useState([]);
  const [editData, setEditData] = useState(null);
  const [categories, setCategories] = useState([]);
  const [product, setProduct] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [executions, setExecutions] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const navigate = useNavigate();
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedChecklist, setSelectedChecklist] = useState(null);
  const [messageApi, contextHolder] = message.useMessage();
  const [comportData, setComportData] = useState({});
  const [currentRow, setCurrentRow] = useState(0);
  const [rows, setRows] = useState([]);
  const [skipModalOpen, setSkipModalOpen] = useState(false);
  const [skipReason, setSkipReason] = useState("");

  const getChickListByProductId = async (productId, preselectChecklistId) => {
    setSelectedProduct(productId);
    setIsLoading(true);
    try {
      const res = await fetchBuildersByProductId(productId);
      setExecutions(res.data);

      // ✅ only after executions are ready
      if (preselectChecklistId) {
        setSelectedChecklist(preselectChecklistId);
        const selected = res.data.find(
          (exec) => exec.uuid === preselectChecklistId
        );
        if (selected) {
          let normalized = (selected.records || []).map((r) => ({
            ...r,
            key: r.uuid || Date.now(),
            liveImages: r.liveImages || [],
            sampleImages: r.sampleImages || [],
          }));
          const mergeWithObservations = (templateRecords, observations) => {
            return templateRecords.map((r) => {
              const obs = observations.find((o) => o.recordId === r.uuid);
              return {
                ...r,
                value: obs ? obs.value : r.value,
              };
            });
          };

          if (editData?.observations) {
            normalized = mergeWithObservations(
              normalized,
              editData.observations
            );
          }

          setRows(normalized);
          setCurrentRow(0);
        }
      } else {
        setSelectedChecklist(null);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const DEVICE_ID = "qwertyuil";

  const columns = [
    {
      title: "DeviceType",
      dataIndex: "deviceTypeId",
      key: "deviceTypeId",
      render: (_, record) =>
        categories.find((cat) => cat.id === record.deviceTypeId)?.deviceType,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (_, record) => record.description,
    },
    {
      title: "Value",
      dataIndex: "value",
      key: "value",
      render: (value, record) => {
        if (record.inputType !== "DOUBLE") return "-";
        return `${value} ${record.unit}`;
      },
    },
    {
      title: "Tolerance",
      dataIndex: "tolerance",
      key: "tolerance",
      render: (value, record) => {
        if (record.inputType !== "DOUBLE") return "-";
        return `± ${value} ${record.unit}`;
      },
    },
    {
      title: "Observation",
      dataIndex: "response",
      key: "response",
      render: (_, record, index) => {
        switch (record.inputType) {
          case "OK_NOT_OK":
            return (
              <div style={{ display: "flex", gap: "1rem" }}>
                <Checkbox
                  checked={record.measuredValue === true}
                  disabled={mode === "view"}
                  onChange={() => {
                    record.measuredValue = true;
                    setRecords([...records]);
                  }}
                >
                  OK
                </Checkbox>
                <Checkbox
                  checked={record.measuredValue === false}
                  disabled={mode === "view"}
                  onChange={() => {
                    record.measuredValue = false;
                    setRecords([...records]);
                  }}
                >
                  NOT OK
                </Checkbox>
              </div>
            );

          case "OPTIONS":
            return (
              <Radio.Group
                value={record.measuredValue}
                disabled={mode === "view"}
                onChange={(e) => {
                  record.measuredValue = e.target.value;
                  setRecords([...records]);
                }}
              >
                {record.options?.map((opt, idx) => (
                  <Radio key={idx} value={opt}>
                    {opt}
                  </Radio>
                ))}
              </Radio.Group>
            );

          case "STRING":
            return (
              <Input
                // defaultValue={record.value}
                value={record.measuredValue || ""}
                disabled={mode === "view"}
                onChange={(e) => {
                  record.measuredValue = e.target.value;
                  setRecords([...records]);
                }}
              />
            );

          case "DOUBLE":
            return (
              <Input
                value={record.observation ?? ""}
                disabled={index !== currentRow || mode === "view"}
                status={
                  record.decision === "REJECT"
                    ? "error"
                    : record.decision === "REWORK"
                    ? "warning"
                    : ""
                }
                placeholder={
                  index === currentRow ? "Waiting for device data..." : "Locked"
                }
              />
            );

          default:
            return <span>-</span>;
        }
      },
    },
    // {
    //   title: "Decision",
    //   key: "decision",
    //   align: "center",
    //   render: (_, record) => {
    //     const decision = getDecision(record);

    //     const colorMap = {
    //       ACCEPTED: "green",
    //       REJECT: "red",
    //       REWORK: "orange",
    //     };

    //     return (
    //       <span
    //         style={{
    //           fontWeight: 600,
    //           color: colorMap[decision] || "#999",
    //         }}
    //       >
    //         {decision || "-"}
    //       </span>
    //     );
    //   },
    // },
    {
      title: "Decision",
      key: "decision",
      align: "center",
      render: (_, record) => {
        // 🔹 DOUBLE → auto decision
        if (record.inputType === "DOUBLE") {
          return (
            <span
              style={{
                fontWeight: 600,
                color:
                  record.decision === "ACCEPTED"
                    ? "green"
                    : record.decision === "REJECT"
                    ? "red"
                    : record.decision === "REWORK"
                    ? "orange"
                    : "#999",
              }}
            >
              {record.decision || "-"}
            </span>
          );
        }

        // 🔹 NON-DOUBLE → user selects decision
        return (
          <Select
            style={{ width: 140 }}
            placeholder="Select"
            value={record.decision}
            disabled={mode === "view"}
            options={DECISION_OPTIONS}
            onChange={(value) => {
              record.decision = value;
              setRecords([...records]);
            }}
          />
        );
      },
    },
    {
      title: "Action",
      key: "action",
      render: (_, record, index) => {
        if (record.inputType !== "DOUBLE") return null;

        if (
          index === currentRow &&
          (record.decision === "REJECT" || record.decision === "REWORK")
        ) {
          return (
            <Button danger onClick={() => setSkipModalOpen(true)}>
              Skip
            </Button>
          );
        }

        return null;
      },
    },
    {
      title: "Sample Images",
      dataIndex: "sampleImages",
      key: "sampleImages",
      render: (_, record) => (
        <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
          {record.sampleImages?.map((img, idx) => {
            let src = "";

            // ✅ case 1: image object with base64
            if (img?.base64) {
              src = `data:image/webp;base64,${img.base64}`;
            }
            // ✅ case 2: image object with url
            else if (img?.url) {
              src = img.url;
            }
            // ✅ case 3: raw base64 string (fallback)
            else if (typeof img === "string") {
              src = `data:image/png;base64,${img}`;
            }

            if (!src) return null;

            return (
              <img
                key={idx}
                src={src}
                alt={img.fileName || `sample-${idx}`}
                style={{
                  width: 100,
                  height: 100,
                  objectFit: "cover",
                  borderRadius: 4,
                  cursor: "pointer",
                }}
                // onClick={() => {
                //   setIsModalOpen(true);
                //   setSelectedImage(src);
                // }}
                onClick={() => {
                  setIsModalOpen(true);
                  setSelectedImage({
                    base64: img.base64,
                    dimensions: img.dimensions || [],
                    originalSize: {
                      width: img.width, // MUST come from backend
                      height: img.height, // MUST come from backend
                    },
                  });
                }}
              />
            );
          })}

          {(!record.sampleImages || record.sampleImages.length === 0) &&
            "No image available"}
        </div>
      ),
    },
  ];
  const evaluateObservation = (row, observation) => {
    const lower = row.value - row.tolerance;
    const upper = row.value + row.tolerance;

    if (observation >= lower && observation <= upper) {
      return "ACCEPTED";
    }
    if (observation < lower) {
      return row.lowerAction; // REJECT / REWORK
    }
    return row.upperAction; // REJECT / REWORK
  };
  const handleComportData = (comportData, deviceType) => {
    if (comportData.port !== deviceType.serialConfig.port) return;

    const payload = Number(comportData.payload);
    const row = rows[currentRow];
    if (!row) return;

    const decision = evaluateObservation(row, payload);

    const updated = [...rows];
    updated[currentRow] = {
      ...row,
      observation: payload,
      decision,
    };

    setRows(updated);

    if (decision === "ACCEPTED") {
      setCurrentRow((prev) => prev + 1);
    }
  };

  const onFinish = (values) => {
    const payload = {
      serialNumber: values.serialNumber, // unique id
      productId: selectedProduct,
      checklistId: selectedChecklist,
      observations: records.map((r) => ({
        recordId: r.uuid || null, // optional: link to checklist record
        inputType: r.inputType, // send type for backend parsing
        value: r.value, // actual observation
        liveImages: r.liveImages || [],
      })),
    };

    saveData(payload);
  };

  const saveData = async (data) => {
    setIsLoading(true);
    try {
      let res;
      if (editData) res = await putExecution(data, editData.uuid);
      else res = await postExecution(data);
      messageApi.open({
        type: "success",
        content: `Execution ${editData ? "updated" : "added"} successfully`,
      });

      if (editData) {
        setTimeout(() => {
          navigate({ pathname: "/check-list" });
        }, 2000);
      } else {
        form.resetFields(["serialNumber"]);
        setRecords((prev) =>
          prev.map((r) => ({
            ...r,
            value: undefined,
          }))
        );
      }
    } catch {
      messageApi.open({
        type: "error",
        content: "Error saving execution",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const onSelectTemplate = (value) => {
    setSelectedChecklist(value); // ✅ capture checklistId
    const selected = executions.find((exec) => exec.uuid === value);

    const normalized = (selected?.records || []).map((r) => ({
      ...r,
      key: r.uuid || Date.now(),
      sampleImages: r.sampleImages || [],
    }));

    setRows(normalized);
    setCurrentRow(0);
  };

  const buildTreeData = (nodes) =>
    nodes.map((node) => {
      // const isLeaf = !node.children || node.children.length === 0;
      return {
        title: node.productName,
        value: node.uuid,
        key: node.uuid,
        // selectable: isLeaf,
        // disabled: !isLeaf,
        children: node.children ? buildTreeData(node.children) : [],
      };
    });

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      try {
        const res = await fetchProduct();
        setProduct(buildTreeData(res.data));

        if (editData) {
          form.setFieldsValue({ serialNumber: editData.serialNumber });
          getChickListByProductId(editData.productId, editData.checklistId);

          // also load existing execution record rows (observations, images, etc.)
          const initialRecords = (
            editData.checkListExecutionRecordList || []
          ).map((r) => ({
            ...r,
            key: r.uuid || Date.now(),
            liveImages: r.liveImages || [],
            sampleImages: r.sampleImages || [],
          }));
          setRecords(initialRecords);
        } else {
          form.resetFields();
          setRecords([]);
        }
      } catch (err) {
        messageApi.open({
          type: "error",
          content: "Network error while fetching products",
        });
      } finally {
        setIsLoading(false);
      }
      setIsLoading(true);
      try {
        const res = await fetchDeviceTypeForFilter();
        setCategories(res.data);
      } catch (err) {
        messageApi.open({
          type: "error",
          content: "Network error while fetching device type",
        });
      } finally {
        setIsLoading(false);
      }
    })();
  }, [editData, form]);

  useEffect(() => {
    if (id) {
      // Fetch existing data for editing
      const fetchData = async () => {
        const res = await fetchExecutionById(id);
        setEditData(res.data);
      };
      fetchData();
    }
  }, [id]);

  const getFileName = (type) => {
    const checklistName =
      executions.find((exec) => exec.uuid === selectedChecklist)
        ?.checklistName || "Checklist";
    const timestamp = new Date()
      .toISOString()
      .slice(0, 19)
      .replace(/[:T]/g, "-");
    return `${checklistName}_${timestamp}.${type}`;
  };

  console.log("product", product, selectedProduct);

  // const productName =
  //   product.find((p) => p.value === selectedProduct)?.title || "";
  function findTitleByValue(tree, value) {
    for (const node of tree) {
      if (node.value === value) return node.title;
      if (node.children) {
        const childResult = findTitleByValue(node.children, value);
        if (childResult) return childResult;
      }
    }
    return "";
  }

  const productName = findTitleByValue(product, selectedProduct);

  const checklistName =
    executions.find((e) => e.uuid === selectedChecklist)?.checklistName || "";
  const serialNumber = form.getFieldValue("serialNumber") || "";
  const createdAt = editData?.createdAt || new Date();
  const updatedAt = editData?.updatedAt || new Date();
  const handleMessage = (data) => {
    // console.log("sasi",data)
    const tempData = {...data,payload:extractValue(data.payload)}
    console.log("sasi",tempData)
    setComportData(tempData); // ONLY store data
  };
  function extractValue(input) {
  const match = input.match(/([+-]?\d+\.\d+)/);
  return match ? Number(match[1]) : null;
}

// Examples
// console.log(extractValue("4 MW +00030.07 mm")); // 30.07
// console.log(extractValue("5 MW +00099.45 mm")); // 99.45

  useEffect(() => {
    if (!comportData?.port) return;

    const row = rows[currentRow];
    if (!row) return;

    // 🔒 Only DOUBLE rows
    if (row.inputType !== "DOUBLE") return;

    // 🔌 Port must match
    const device = categories.find((c) => c.id === row.deviceTypeId);

    if (!device?.serialConfig?.port) return;
    if (device.serialConfig.port !== comportData.port) return;

    const payload = Number(comportData.payload);
    if (Number.isNaN(payload)) return;

    const decision = evaluateObservation(row, payload);

    const updated = [...rows];
    updated[currentRow] = {
      ...row,
      observation: payload,
      decision,
    };

    setRows(updated);

    if (decision === "ACCEPTED") {
      setCurrentRow((prev) => prev + 1);
    }
  }, [comportData]); // 👈 THIS IS CRITICAL

  return (
    <Spin spinning={isLoading}>
      {console.log("comportData", comportData)}
      <div style={{ fontSize: "1rem", fontWeight: 700 }}>
        Quality Plan Execution
      </div>
      <ComportMqttListener onMessage={handleMessage} />
      {contextHolder}
      <br />
      <Row gutter={[16, 16]}>
        <Col span={8}>
          <TreeSelect
            value={selectedProduct}
            disabled={mode === "view"}
            treeData={product}
            placeholder="Select Product"
            style={{ width: "100%", minWidth: 240 }}
            treeDefaultExpandAll={false}
            onChange={(value) => getChickListByProductId(value)}
          />
        </Col>
        {executions.length > 0 && (
          <Col span={8}>
            <Select
              value={selectedChecklist}
              placeholder="Select Checklist"
              disabled={mode === "view"}
              style={{ width: "100%", minWidth: 240 }}
              options={executions.map((exec) => ({
                label: exec.procedureName,
                value: exec.uuid,
              }))}
              onChange={onSelectTemplate}
            />
          </Col>
        )}
        {mode === "view" && (
          <Col span={8}>
            <Button
              style={{ marginRight: "1rem" }}
              onClick={() =>
                // exportToPDF(records, categories, getFileName("pdf"))
                exportToPDF(
                  records,
                  categories,
                  productName,
                  checklistName,
                  serialNumber,
                  createdAt,
                  updatedAt,
                  getFileName("pdf")
                )
              }
            >
              Download PDF
            </Button>
            <Button
              onClick={() =>
                // exportToExcel(records, categories, getFileName("xlsx"))
                exportToExcel(
                  records,
                  categories,
                  productName,
                  checklistName,
                  serialNumber,
                  createdAt,
                  updatedAt,
                  getFileName("xlsx")
                )
              }
            >
              Download Excel
            </Button>
          </Col>
        )}
      </Row>
      <br />
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          name="serialNumber"
          label="Serial Number"
          rules={[{ required: true, message: "Please input serial number!" }]}
        >
          <Input disabled={mode === "view"} />
        </Form.Item>

        <Table
          rowKey="key"
          scroll={{ x: "max-content" }}
          columns={columns}
          disabled={mode === "view"}
          dataSource={rows}
          // dataSource={records} // ✅ use state, not template
          pagination={false}
        />

        <Form.Item
          style={{
            marginTop: 20,
            textAlign: "right",
          }}
        >
          <Button
            style={{ marginRight: "1rem" }}
            onClick={() => {
              navigate({ pathname: "/check-list-builder/check-list" });
            }}
          >
            Cancel
          </Button>
          {mode === "view" || (
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          )}
        </Form.Item>
      </Form>
      <Modal
        title="Image Preview"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
      >
        {selectedImage && (
          <ImageWithDimensions
            base64={selectedImage.base64}
            dimensions={selectedImage.dimensions}
          />
        )}
      </Modal>
      <Modal
        title="Skip Observation"
        open={skipModalOpen}
        onCancel={() => setSkipModalOpen(false)}
        onOk={() => {
          if (!skipReason.trim()) return;

          const updated = [...rows];
          updated[currentRow] = {
            ...updated[currentRow],
            skipped: true,
            skipReason,
          };

          setRows(updated);
          setSkipReason("");
          setSkipModalOpen(false);
          setCurrentRow((prev) => prev + 1);
        }}
      >
        <Input.TextArea
          rows={3}
          placeholder="Reason for skipping is mandatory"
          value={skipReason}
          onChange={(e) => setSkipReason(e.target.value)}
        />
      </Modal>
    </Spin>
  );
};

export default QualityPlanChecklistExecutionForm;
